import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { Smartphone } from '../model/smartphone';
import { Identity } from '@sdbn/common';
import { SmartphoneDetails } from '../model/smartphone-details';
import { ServiceResponse } from '@sdbn/common';

@Injectable({
    providedIn: 'root'
  })
  export class SmartphoneService {

    constructor(private appServerAPI: AppServerAPI) { }

    getSmartphones(): Observable<Smartphone[]> {
      return this.appServerAPI.execute<Smartphone[]>('/client/admin/smartphone', {});
    }

    getSmartphoneDetails(identity: Identity): Observable<SmartphoneDetails> {
      return this.appServerAPI.execute<SmartphoneDetails>('/client/admin/smartphone/details', identity);
    }

    saveSmartphone(smartphone: SmartphoneDetails): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/smartphone/save', smartphone);
    }

    createSmartphone(smartphone: SmartphoneDetails): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/smartphone/create', smartphone);
    }

    deleteSmartphone(identity: Identity): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/smartphone/delete', identity);
    }
  }
